export const NAME = "orders/detail" as const;
